import { render } from "./StpnTypesView.vue?vue&type=template&id=1c282179"
import script from "./StpnTypesView.vue?vue&type=script&lang=js"
export * from "./StpnTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__